// import Example from '../components/example.svelte'
import Siema from 'siema'
import HomeShowcase from '../components/home-showcase.svelte'

export default {
	init() {
		let $heroHome = $('#hero_home')

		new HomeShowcase({
			target: $heroHome[0],
			props: $heroHome.data(),
		})
	},
	finalize() {
		instaCarousel()
	},
}

function instaCarousel() {
	let $carousel = $('.insta-carousel')
	if ($carousel.length) {
		new Siema({
			selector: $carousel[0],
			duration: 400,
			easing: 'ease',
			loop: true,
			startIndex: -1,
			perPage: {
				2200: 7,
				1750: 6,
				1200: 5,
				800: 4,
				100: 3,
			},
		})
	}
}
